import SearchIcon from '@mui/icons-material/Search';

export const BusquedaInput = ({searchText, onInputChange, listSearchAutocomplete, onSearchResultInput}) => {
  return (
    <div className="headShearch">
      <div className='inputSearch'>
        <input  type='text'
                name='searchText'
                autoComplete='off'
                placeholder='Explora las colecciones de El Brujo'
                value={searchText}
                onChange={onInputChange} />
        <ul className={listSearchAutocomplete.length === 0 ? 'invisible' : 'dropdown-menu show listSearch'}>
          {
            listSearchAutocomplete.map((item, index) => {
              return(
                <li key={index} onClick={() => {onSearchResultInput(item, "", 0, 0, 0 ,0, "")}} className='dropdown-item'>{ item }</li>
              )
            })
          }
        </ul>
        <SearchIcon className='button-search' onClick={() => {onSearchResultInput(searchText, "", 0, 0, 0 ,0, "")}}/>
      </div>
    </div>
  )
}
